var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.25C15.9142 15.25 16.25 14.9142 16.25 14.5C16.25 14.0858 15.9142 13.75 15.5 13.75C15.0858 13.75 14.75 14.0858 14.75 14.5C14.75 14.9142 15.0858 15.25 15.5 15.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 3C15.7315 3 17 4.26854 17 5.83333V8H17.25C19.3211 8 21 9.67889 21 11.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67894 21 3 19.3211 3 17.25V6.5C3 4.56701 4.56701 3 6.5 3H14.1667ZM4.5 6.5C4.5 5.39543 5.39543 4.5 6.5 4.5H14.1667C14.9031 4.5 15.5 5.09694 15.5 5.83333V8H6C5.17157 8 4.5 7.32843 4.5 6.5ZM6.75 19.5C5.50736 19.5 4.5 18.4927 4.5 17.25V9.09865C4.94126 9.35391 5.45357 9.5 6 9.5H17.25C18.4927 9.5 19.5 10.5073 19.5 11.75V17.25C19.5 18.4927 18.4927 19.5 17.25 19.5H6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet3);
export default __webpack_public_path__ + "static/media/wallet-3.728047368f837dd8d218d07e1f32e722.svg";
export { ForwardRef as ReactComponent };